import ChangeLanguage from 'components/ChangeLanguage';
import LoginPage from 'components/LoginPage';
import UserLoginImageContainer from 'components/UserLoginImageContainer';
import i18n from 'i18n';
import React from 'react';
import ButtonComponent from 'components/ButtonComponent';
import { connect } from 'react-redux';
import { history } from 'store';
import LoginForm from './LoginForm';
import { Grid, makeStyles } from '@material-ui/core';
import styles from './styles';
import { defaultLinks } from 'utils/helpers';

export const links = [
  defaultLinks[i18n.t('PRIVACY_POLICY_KEY')] ||
    defaultLinks['Política de Privacidade'],
  defaultLinks[i18n.t('CODE_OF_ETHICS_AND_CONDUCT_KEY')] ||
    defaultLinks['Código de Ética e Conduta'],
];

interface Props {
  token?: string;
  config: any;
  shouldUpdatePlugin: boolean;
}

const Login: React.FC<Props> = ({ token, config, shouldUpdatePlugin }) => {
  React.useEffect(() => {
    if (!token) history.push('/');
  }, [token, shouldUpdatePlugin]);

  const classes = makeStyles(styles)();

  return (
    <LoginPage
      imageWrapper={
        <UserLoginImageContainer
          bgImage={config?.imageUrl}
          description={i18n.t('DESCRIPTION_LOGIN_KEY')}
          header={i18n.t('WELCOME_KEY')}
          imageColor={config?.imageLoginBackgroundColor}
        />
      }
      links={links}
      logoUrl={config?.logoUrl}
      changeLanguage={<ChangeLanguage />}
    >
      <LoginForm />
      <Grid container className={classes.corporateContainer}>
        <ButtonComponent
          onClick={() => history.push('/sso')}
          type="submit"
          variant="contained"
          removeUpperCase
          style={{
            boxShadow: 'none',
            fontSize: '14px',
            color: 'black',
            background: '#D9D9D9',
          }}
        >
          {i18n.t('CORPORATE_TITLE_KEY')}
        </ButtonComponent>
      </Grid>
    </LoginPage>
  );
};

const mapStateToProps = ({ auth, config }) => ({
  token: auth.isAuthenticate?.access_token,
  config,
  shouldUpdatePlugin: auth.shouldUpdatePlugin,
});

export default connect(mapStateToProps)(Login);
